import { useStore } from "@shared/store/useStore";
import { type AuthProfileSerializer } from "@shared/modules/auth/types";
import { AuthRepository } from "../AuthRepository";
import { IAuthStrategy } from "../interfaces/IAuthStrategy";

export class SessionClient implements IAuthStrategy {
  private authRepo: AuthRepository;

  constructor() {
    this.authRepo = new AuthRepository();
  }

  private static setUser(user: AuthProfileSerializer | undefined): void {
    useStore.setState({ user });
  }

  public async login(
    email: string,
    password: string,
    {
      otp_token,
      captcha_token,
    }: {
      otp_token?: string;
      captcha_token: string | undefined;
    }
  ) {
    const data = await this.authRepo.login({
      email,
      password,
      otp_token,
      captcha_token,
    });
    const { user } = data;
    SessionClient.setUser(user);

    return data;
  }

  public async loginWithGoogle(code: string) {
    const data = await this.authRepo.loginWithGoogle(code);
    const { user } = data;
    SessionClient.setUser(user);

    return data;
  }

  public async loginWithFacebook(access_token: string) {
    const data = await this.authRepo.loginWithFacebook(access_token);
    const { user } = data;
    SessionClient.setUser(user);

    return data;
  }

  public logout() {
    SessionClient.setUser(undefined);
    return this.authRepo.logout();
  }
}
